<template>
    <div>
        <div class="card-header">
            <div class="text-left">
                <button @click="modal()" class="btn btn-success">
                    <i class="fas fa-plus"></i> {{ $t("lang.label_add") }}
                </button>
            </div>
        </div>
        <div class="card-body" v-if="isLoading === true">
            <loader></loader>
        </div>
        <div class="card-body" v-else>
            <table class="table table-hover" id="tableID">
                <thead>
                    <tr>
                        <th scope="col">{{ $t("lang.label_name") }}</th>
                        <th scope="col">{{ $t("lang.label_name_preview") }}</th>
                        <th scope="col" style="width: 10px">
                            {{ $t("lang.msj_status") }}
                        </th>
                        <th scope="col" colspan="2" style="width: 10px">
                            {{ $t("lang.label_action") }}
                        </th>
                    </tr>
                </thead>
                <tbody v-if="result.length === 0">
                    <tr>
                        <th colspan="10">
                            <div style="text-align: center">
                                {{ $t("lang.label_nrecord") }}
                            </div>
                        </th>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr v-for="(i, index) in result" :key="index">
                        <td>
                            <input
                                type="text"
                                @change="editCampNVariant(i, index, result)"
                                :maxlength="100"
                                v-model="i.name"
                                class="form-control editables"
                            />
                        </td>
                        <td>
                            <input
                                type="text"
                                @change="editCampNVariant(i, index, result)"
                                :maxlength="100"
                                v-model="i.preview_name"
                                class="form-control editables"
                            />
                        </td>
                        <td>
                            <div class="onoffswitch">
                                <input
                                    type="checkbox"
                                    :id="'cat' + i.id"
                                    :checked="i.status"
                                    class="onoffswitch-checkbox"
                                    @click="changeStatusVariant(i)"
                                />
                                <label class="onoffswitch-label" :for="'cat' + i.id">
                                    <span class="onoffswitch-inner"></span>
                                    <span class="onoffswitch-switch"></span>
                                </label>
                            </div>
                        </td>
                        <td style="width: 10px">
                            <a
                                class="btn btn-warning btn-sm mr-2"
                                @click="edits(i, result)"
                            >
                                <i class="fas fa-pen fa-lg"></i>
                            </a>
                        </td>
                        <td style="width: 10px">
                            <a
                                class="btn btn-danger btn-sm mr-2"
                                @click="deleteVariant(i)"
                            >
                                <i class="fas fa-trash fa-lg"></i>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="card-footer"></div>
        <!-- modal -->
        <modalLateral>
            <component v-bind:is="m.component"></component>
        </modalLateral>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import variantForm from "@/components/dimenu/menu/variantForm";
import modalLateral from "@/components/themeModalLateral/modalLateral";
import Loader from "@/components/shared/Loader";
export default {
    name: "variantLista",
    components: {
        Loader,
        variantForm,
        modalLateral,
    },
    data () {
        return {
            isLoading: false,
            result: [],
            m: {
                show: false,
                component: "",
                data: [],
            },
            f: {
                org_id: window.localuserdata,
                user_id: window.localAccountID,
                id: 0,
                name: "",
                preview_name: 0,
                status: 0,
            },
        }
    },
    created () {
        this.getData();
    },
    methods: {
        edits(i, result) {
            this.m = {
                show: true,
                component: "variantForm",
                action: "editForm",
                data: {
                    dat: i,
                    actionForm: "update",
                    validar: result,
                },
            };
            this.$store.commit("setOpenModal", this.m);
        },
        modal() {
            let dat = {
                name: "",
                preview_name: "",
                id: 0,
            };
            this.m = {
                show: true,
                component: "variantForm",
                action: "addForm",
                data: {
                    dat: dat,
                    actionForm: "create",
                },
            };
            this.$store.commit("setOpenModal", this.m);
        },
        getData() {
            this.isLoading = true;
            let url = "/menu/variantcat";
            window.master
                .post(url, this.f)
                .then((response) => {
                    // console.log('data variantList',response.data.res)
                    let u = response.data.res;
                    this.result = u;
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.isLoading = false;
                });
        },
        changeStatusVariant(b) {
            let active = 0;
            if (b.status) {
                active = 0;
            } else {
                active = 1;
            }
            this.f.id = b.id;
            this.f.name = b.name;
            this.f.preview_name = b.preview_name;
            this.f.status = active;
            let url = "/menu/variantcat/updateCat";
            window.master
                .post(url, this.f)
                .then((response) => {
                    b.status = !b.status;
                    // console.log(response.data);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        editCampNVariant(b, index, result) {
            let e = this.validate(b, result);
            if (e.length === 1) {
                let name = b.name.length;
                let preview_name = b.preview_name.length;
                if (preview_name === "" || name === 0) {
                    this.$swal({
                        title: "Error",
                        text: "El campo esta vacio.",
                        type: "warning",
                        showCancelButton: false,
                        confirmButtonColor: "#3085d6",
                    });
                } else {
                    this.f.id = b.id;
                    this.f.name = b.name;
                    this.f.preview_name = b.preview_name;
                    this.f.status = b.status;
                    let url = "/menu/variantcat/updateCat";
                    window.master
                        .post(url, this.f)
                        .then((response) => {
                            console.log(response.data);
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            } else {
                this.$swal({
                    title: "Error",
                    text: "Ya existe un conjunto de opciones con ese nombre.",
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonColor: "#3085d6",
                });
                this.getData();
            }
        },
        validate(b, result) {
            let a = [];
            let name = b.name;
            let id = b.id;
            let r = result;
            for (let i in r) {
                if (id !== r[i].id) {
                    if (name === r[i].name) {
                        a.push(true);
                    } else {
                        a.push(false);
                    }
                }
            }
            for (var i = a.length - 1; i >= 0; i--) {
                if (a.indexOf(a[i]) !== i) {
                    a.splice(i, 1);
                }
            }
            return a;
        },
        deleteVariant(b) {
            if (b.idPrices > 0) {
                this.$swal.fire({
                    type: "warning",
                    title: "Eliminar!",
                    text: "Este Variant esta siendo usado",
                    showConfirmButton: false,
                    timer: 2000,
                });
            } else {
                this.$swal({
                    title: "Eliminar",
                    text: "Esta Seguro",
                    // text: "you cannot delete this Variant",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                }).then((result) => {
                    if (result.value) {
                        this.f.id = b.id;
                        window.master
                            .post("/menu/variantcat/delCat", this.f)
                            .then((response) => {
                                this.getData();
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    }
                });
            }
        },
    },
    watch: {
        getOpenModal: function () {
            if (this.getOpenModal.show === false) {
                this.getData();
            }
        },
    },
    computed: {
        ...mapGetters(["getOpenModal"]),
    },
}
</script>
<style lang="scss" scoped>
.onoffswitch-checkbox {
    display: none;
}
.onoffswitch-label {
    display: block;
    overflow: hidden;
    cursor: pointer;
    text-align: left;
    //border: 1px solid #fff;
    border-radius: 20px;
}
.onoffswitch-inner {
    display: block;
    width: 200%;
    margin-left: -100%;
    transition: margin 0.1s ease-in 0s;
}
.onoffswitch-inner:before,
.onoffswitch-inner:after {
    display: block;
    float: left;
    width: 50%;
    height: 21px;
    padding: 0;
    line-height: 20px;
    font-size: 12px;
    color: white;
    font-family: Trebuchet, Arial, sans-serif;
    font-weight: bold;
    box-sizing: border-box;
}
.onoffswitch-inner:before {
    content: "Encendido";
    padding-left: 10px;
    background-color: #5ac146;
    color: #ffffff;
}
.onoffswitch-inner:after {
    content: "Apagado";
    padding-right: 10px;
    background-color: #d65353;
    color: #fff;
    text-align: right;
}
.onoffswitch-switch {
    display: none;
    width: 15px;
    height: 15px;
    margin: 6px;
    background: #fff;
    position: absolute;
    top: -3px;
    bottom: 0;
    right: 33px;
    //border: 1px solid #5ac146;
    border-radius: 20px;
    transition: all 0.1s ease-in 0s;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
    margin-left: 0;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
    right: 0px;
}
.form-control.editables {
    border: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    background: transparent;
    font-size: 12px;
    padding: 0;
}
.form-control {
    display: inherit !important;
    width: 90% !important;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
input[type="number"] {
    -moz-appearance: textfield;
}
a:not([href]):not([tabindex]) {
    color: white;
    /* color: inherit; */
    text-decoration: none;
}
</style>
